import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MobileService = {
    hasMobile: async () => axios.get(API_URL + `/has-mobile`).then(({data}) => data).catch((err) => { throw err })
}

export default MobileService;
